export default function getImageUrl(path = "") {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("https")) return path;

  const serverUrl = process.env.REACT_APP_SERVER_URL.split("/api")[0];
  return `${serverUrl}/uploads/${path}`;
}
